"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnderlinedStyle = void 0;
function getUnderlinedStyle(color) {
    return {
        _after: {
            content: '""',
            position: 'absolute',
            bottom: '12px',
            left: '8px',
            width: 'calc(100% - 16px)',
            top: '32px',
            borderBottom: "2px ".concat(color, " solid"),
        },
    };
}
exports.getUnderlinedStyle = getUnderlinedStyle;
